import {GameStyleType} from "../types/types";
const prepareRounds = (rounds: GameStyleType["rounds"],type : GameStyleType["type"]) => {
  return rounds.map((round) => ({
    ...round,
    textBySyllables: round.textBySyllables.map((line) => {
      const parts = line.split("|");

      if (
        type === "2" &&
        parts.length > 1 &&
        parts[parts.length - 1].length === 2
      ) {
        parts[parts.length - 1] += "_";
      }

      return parts.join("|");
    }),
  }));
};
export default prepareRounds;